/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData, resetPrivilegedTokensAndUpdate } from '@gh/common-shared';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { SystemVarsJobDetails } from '../../resources/model/system-vars-jobs.model';
import { SystemVarsJobsBusinessService } from '../../resources/system-vars-jobs-business.service';
import { SystemVarsJobsCommonSettingsSubTabFormState } from './sys-vars-jobs-common-settings-subtab/sys-vars-jobs-common-settings-subtab.form.service';
import { SystemVarsJobsTabFormState } from './system-vars-jobs-tab.form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-jobs-tab',
  templateUrl: 'system-vars-jobs-tab.component.html',
  styleUrls: ['system-vars-jobs-tab.component.scss'],
  viewProviders: [
    SystemVarsJobsTabFormState,
    SystemVarsJobsCommonSettingsSubTabFormState,
  ],
})
export class SystemVarsJobsTabComponent extends AbstractFormComponent<SystemVarsJobDetails> implements OnInit {
  currentTab: string = 'commonSettings';
  private sysVarsJob: SystemVarsJobDetails;

  constructor(private route: ActivatedRoute,
              public form: SystemVarsJobsTabFormState,
              private businessService: SystemVarsJobsBusinessService,
              private dialogService: DialogService,
              private pipelines: FormActionPipelines,
              private actions: CommonActions,
              private navigationService: BuilderNavigationService,
              private userContext: BuilderUserContext) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsJobDetails>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<SystemVarsJobDetails>) =>
        this.businessService.save(state.form.submitValue)),
      finish: (state: FormFlowState<SystemVarsJobDetails>) => {
        const { value } = state;
        this.sysVarsJob = value;
        this.form.build(value);
      },
    });
  }

  ngOnInit(): void {
    const { sysVarsJob } = getRouteInitData(this.route);
    assign(this, { sysVarsJob });

    this.form.build(sysVarsJob);
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.userContext.office && this.userContext.office.id,
      entityType: 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedJobs],
      label: 'lbl_jobs',
    });
  }

  onTabChanged(subTab: string): void {
    this.currentTab = subTab;
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => {
        resetPrivilegedTokensAndUpdate(this.form);
        this.form.build(this.sysVarsJob);
      });
  }
}
